$(document).ready(function() {
    $('#orderAgainReplaceProducts').click(function () {
        $('#orderAgainType').val('replace');
        if ($(this).hasAttr('href-url')) {
            window.location.href = $(this).attr('href-url');
        } else {
            $('#orderAgainForm').submit();
        }
        $(this).attr("disabled", "disabled");
        $('#orderAgainMergeProducts').attr("disabled", "disabled");
        $(this).html($(this).attr('submit-text'));
    });

    $('#deleteCart').click(function () {
        if ($(this).hasAttr('href-url')) {
            window.location.href = $(this).attr('href-url');
        }
        $(this).attr("disabled", "disabled");
    });

    $('#orderAgainMergeProducts').click(function () {
        $('#orderAgainType').val('add');
        if ($(this).hasAttr('href-url')) {
            window.location.href = $(this).attr('href-url');
        } else {
            $('#orderAgainForm').submit();
        }
        $(this).attr("disabled", "disabled");
        $('#orderAgainReplaceProducts').attr("disabled", "disabled");
        $(this).html($(this).attr('submit-text'));
    });

    $('.dropdown-item.useCart').click(function () {
        $('#orderAgainMergeProducts').attr('href-url', $(this).attr('cart-merge-url'));
        $('#orderAgainReplaceProducts').attr('href-url', $(this).attr('cart-replace-url'));
    });

    $('.dropdown-item.deleteCart').click(function () {
        $('#deleteCart').attr('href-url', $(this).attr('cart-delete-url'));
    });

    $('.dropdown-item.mailCart').click(function () {
        $('#mailCartId').val($(this).attr('cart-id'));
    });

    $('#mailShoppingCart').click(function () {
        $(this).html($(this).attr('submit-text'));
        $(this).attr("disabled", "disabled");
        $('#mailCartForm').submit();
    });
});
